import { useState } from "react";

import { TextToolState } from "@impero-com/ui";
import { Row } from "@tanstack/react-table";

import { useUpdateUserGroupRightsForUserMutation } from "org/user/queries/useUpdateUserGroupRightsForUserMutation";
import { UserOrUserGroupOverview } from "utils/user";

import { GroupRow } from "./useUserGroupsListTable";

interface UseReplaceGroupUserUtilsProps {
    userId: number;
    selectedRows: Row<GroupRow>[];
    deselectAll: () => void;
}

export function useReplaceGroupUserUtils({
    userId,
    selectedRows,
    deselectAll,
}: UseReplaceGroupUserUtilsProps) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { mutateAsync, isPending } =
        useUpdateUserGroupRightsForUserMutation();

    const replaceUserToolState: TextToolState =
        selectedRows.length === 0 ? { type: "DISABLED" } : { type: "ENABLED" };

    const replaceUser = async (userOrGroup: UserOrUserGroupOverview) => {
        const userGroupIds = selectedRows.map((row) => row.original.id);
        const newUserId = userOrGroup.id;

        try {
            await mutateAsync({ userId, data: { newUserId, userGroupIds } });
            deselectAll();
            setIsModalOpen(false);
        } catch (error) {
            console.error(error);
        }
    };

    return {
        replaceUserToolState,
        isReplaceUserModalOpen: isModalOpen,
        openReplaceUserModal: () => setIsModalOpen(true),
        closeReplaceUserModal: () => setIsModalOpen(false),
        replaceUser,
        isReplacingUser: isPending,
    };
}
